import api from "axios";

export default function getAllAdvertiserType() {
  return api
    .get("/advertiser-type")
    .then(res => res.data.payload)
    .catch((error) => `getAllAdvertiserType ${error}`);
}

export function getFilterData() {
  return api
    .get("/regions")
    .then(res => res.data.payload)
    .catch((error) => {
      return Promise.reject(new Error(`Error in getFilterData: ${error.message}`));
    });
}

export function getDefaultValueFilterInputs() {
  return api
    .get("/purchasers/getDefaultValueFilterInputs")
      .then(r => r.data.payload.data)
      .catch((error) => `Error in getDefaultValueFilterInputs: ${error.message}`);
}

export function getAdvertiserTypeByCompanyUrl(url) {
  return api
    .get(`/advertiser-type/${url}`)
    .then((response) => response.data.payload[0])
    .catch((error) => {
      console.error(`getAdvertiserTypeByCompanyUrl ${error}`);
      return null;
    });
}